module.exports = __webpack_public_path__ + "static/image/service/pc/store@3x.jpg?89966745";